import { ReactElement } from "react";
import { Container, Paper, Stack } from '@mui/material';

// components
import SoroeruCard from "./components/SoroeruCard";
import InfoCard from "./components/InfoCard";
import CompanyPolicyCard from "./components/PolicyCard";
import { IntroSection } from "../home/components/IntroSection";
import { WorksSection } from "../works/WorksSection";
import { ServicesSection } from "../services/ServicesSection";


const CompanyPage = (): ReactElement => {

  return (
    <Container sx={{ my: 1, pt: 7, maxWidth: "720px !important" }}>
      <InfoCard />
      <SoroeruCard />
      <CompanyPolicyCard />
    </Container>
  );
};

export default CompanyPage;
